/* BG-356 cart add-ons ("Complete your game"). Progressive enhancement: without JS the rows still link to the products. */
/* global trapFocus */

if (!customElements.get('cart-addons')) {
  class CartAddons extends HTMLElement {
    connectedCallback() {
      this.onRegion = (evt) => this.label(evt.detail && evt.detail.tier);
      document.addEventListener('shipping-region:apply', this.onRegion);
      if (!this.bound) {
        this.bound = true;
        this.addEventListener('click', (evt) => {
          const btn = evt.target.closest('.cart-addons__add');
          if (btn && btn.getAttribute('aria-disabled') !== 'true') this.add(btn);
        });
      }
      this.label();
    }

    disconnectedCallback() {
      document.removeEventListener('shipping-region:apply', this.onRegion);
    }

    /**
     * Free-shipping closer: re-decides the labelled row from the shopper's province tier.
     * A province change can only pick among the rows already rendered.
     * @param {string} [tierKey] - Tier key from the shipping-region event (default, f<amount>, n-<note>).
     */
    label(tierKey) {
      const tier = tierKey || (document.querySelector('shipping-region [data-tier-panel].is-active') || {}).dataset?.tierPanel;
      let threshold = Number(this.dataset.threshold) || 0;
      if (tier && tier.charAt(0) === 'f') threshold = Math.round(Number(tier.slice(1)) * 100) || 0;
      else if (tier && tier.indexOf('n-') === 0) threshold = 0;

      const list = this.querySelector('.cart-addons__list');
      const rows = [...list.children].sort((a, b) => a.dataset.rank - b.dataset.rank);
      const gap = threshold - Number(this.dataset.total);
      let closer = null;
      if (gap > 0 && gap <= 5000) {
        rows.forEach((row) => {
          const price = Number(row.dataset.price);
          if (price >= gap && (!closer || price < Number(closer.dataset.price))) closer = row;
        });
      }
      const ordered = closer ? [closer, ...rows.filter((row) => row !== closer)] : rows;
      ordered.forEach((row) => {
        row.classList.toggle('is-closer', row === closer);
        row.querySelector('[data-chip]').hidden = row !== closer;
        list.appendChild(row);
      });
    }

    async add(btn) {
      const row = btn.closest('.cart-addons__row');
      const title = row.querySelector('.cart-addons__title').textContent.trim();
      btn.dataset.state = 'busy';
      // aria-disabled, not disabled: a disabled button drops keyboard focus to <body>
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      const drawer = this.closest('cart-drawer');
      const items = drawer ? drawer.querySelector('cart-items') : document.querySelector('#cart cart-items');

      try {
        const res = await fetch(`${theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _addon: row.dataset.addon } }] })
        });
        const data = await res.json();
        if (!res.ok) {
          const err = new Error(res.status);
          err.description = typeof data.description === 'string' ? data.description : data.message;
          throw err;
        }

        btn.dataset.state = 'done';
        btn.removeAttribute('aria-busy');
        document.getElementById('cart-addons-status').textContent = this.dataset.announce.replace('[title]', title);
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: Number(btn.dataset.variantId) } }));
        await new Promise((resolve) => { setTimeout(resolve, 600); });
        if (items) await items.refresh();

        // this block was replaced by the refresh: pick the focus target in the new one
        const next = document.querySelector('#cart-addons-slot .cart-addons__add')
          || document.getElementById('cart-addons-h')
          || document.querySelector(`.cart-item[data-variant-id="${btn.dataset.variantId}"] a`);
        if (!next) return;
        if (drawer) {
          if (drawer.isConnected && drawer.hasAttribute('open')) trapFocus(drawer, next);
        } else {
          next.focus();
        }
      } catch (error) {
        delete btn.dataset.state;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');
        const msg = theme.safeCartError(error.description);
        const errors = document.getElementById('cart-errors');
        if (errors) {
          errors.textContent = msg;
          errors.hidden = false;
        }
        this.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: msg } }));
      }
    }
  }
  customElements.define('cart-addons', CartAddons);
}
